//
//
//

export default {
    props: {
        link: String
    },
    methods: {
        goPrepaymentCalc() {
            if (this.link) {
                this.$sendCtmEvtLog(`我想提前还款点击`)
                wx.navigateTo({
                    url: this.link
                })
            }
        },
    }
}
